import { Box, Link } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ResetPasswordIcon from "../../../components/icons/ResetPassword";

const ResetPassword = (props: { identityServerUrl: string; email: string }) => {
	const { t } = useTranslation();
	const url = new URL("../send-reset-pwd-email", props.identityServerUrl);
	url.searchParams.set("email", props.email);

	return (
		<Box display="flex">
			<ResetPasswordIcon />
			<Link href={url.href} target="_blank" rel="noreferrer" style={{ marginLeft: "8px" }}>
				{t("reset-password")}
			</Link>
		</Box>
	);
};

export default ResetPassword;
